
var types = {
    "AnPlusB": null,
    "Atrule": {
        "context": "atrule",
        "fields": [
            {
                "name": "prelude",
                "type": "node",
                "nullable": true
            },
            {
                "name": "block",
                "type": "node",
                "nullable": true
            }
        ]
    },
    "AtrulePrelude": {
        "context": "atrulePrelude",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "AttributeSelector": {
        "fields": [
            {
                "name": "name",
                "type": "node",
                "nullable": false
            },
            {
                "name": "value",
                "type": "node",
                "nullable": true
            }
        ]
    },
    "Block": {
        "context": "block",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "Brackets": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "CDC": null,
    "CDO": null,
    "ClassSelector": null,
    "Combinator": null,
    "Comment": null,
    "Declaration": {
        "context": "declaration",
        "fields": [
            {
                "name": "value",
                "type": "node",
                "nullable": false
            }
        ]
    },
    "DeclarationList": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "Dimension": null,
    "Function": {
        "context": "function",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "HexColor": null,
    "Identifier": null,
    "IdSelector": null,
    "MediaFeature": {
        "fields": [
            {
                "name": "value",
                "type": "node",
                "nullable": true
            }
        ]
    },
    "MediaQuery": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "MediaQueryList": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "Nth": {
        "fields": [
            {
                "name": "nth",
                "type": "node",
                "nullable": false
            },
            {
                "name": "selector",
                "type": "node",
                "nullable": true
            }
        ]
    },
    "Number": null,
    "Operator": null,
    "Parentheses": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "Percentage": null,
    "PseudoClassSelector": {
        "context": "function",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": true
            }
        ]
    },
    "PseudoElementSelector": {
        "context": "function",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": true
            }
        ]
    },
    "Ratio": null,
    "Raw": null,
    "Rule": {
        "context": "rule",
        "fields": [
            {
                "name": "prelude",
                "type": "node",
                "nullable": false
            },
            {
                "name": "block",
                "type": "node",
                "nullable": false
            }
        ]
    },
    "Selector": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "SelectorList": {
        "context": "selector",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "String": null,
    "StyleSheet": {
        "context": "stylesheet",
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "TypeSelector": null,
    "UnicodeRange": null,
    "Url": {
        "fields": [
            {
                "name": "value",
                "type": "node",
                "nullable": false
            }
        ]
    },
    "Value": {
        "fields": [
            {
                "name": "children",
                "type": "list",
                "nullable": false
            }
        ]
    },
    "WhiteSpace": null
};

var iteratorsNatural = {
    "Atrule": function AtruleIterator(node, context, walk) {
        var old = context.atrule;
        context.atrule = node;
        if (node.prelude) {
            walk(node.prelude);
        }
        if (node.block) {
            walk(node.block);
        }
        context.atrule = old;
    },
    "AtrulePrelude": function AtrulePreludeIterator(node, context, walk) {
        var old = context.atrulePrelude;
        context.atrulePrelude = node;
        node.children.forEach(walk);
        context.atrulePrelude = old;
    },
    "AttributeSelector": function AttributeSelectorIterator(node, context, walk) {
        walk(node.name);
        if (node.value) {
            walk(node.value);
        }
    },
    "Block": function BlockIterator(node, context, walk) {
        var old = context.block;
        context.block = node;
        node.children.forEach(walk);
        context.block = old;
    },
    "Brackets": function BracketsIterator(node, context, walk) {
        node.children.forEach(walk);
    },
    "Declaration": function DeclarationIterator(node, context, walk) {
        var old = context.declaration;
        context.declaration = node;
        walk(node.value);
        context.declaration = old;
    },
    "DeclarationList": function DeclarationListIterator(node, context, walk) {
        node.children.forEach(walk);
    },
    "Function": function FunctionIterator(node, context, walk) {
        var old = context.function;
        context.function = node;
        node.children.forEach(walk);
        context.function = old;
    },
    "MediaFeature": function MediaFeatureIterator(node, context, walk) {
        if (node.value) {
            walk(node.value);
        }
    },
    "MediaQuery": function MediaQueryIterator(node, context, walk) {
        node.children.forEach(walk);
    },
    "MediaQueryList": function MediaQueryListIterator(node, context, walk) {
        node.children.forEach(walk);
    },
    "Nth": function NthIterator(node, context, walk) {
        walk(node.nth);
        if (node.selector) {
            walk(node.selector);
        }
    },
    "Parentheses": function ParenthesesIterator(node, context, walk) {
        node.children.forEach(walk);
    },
    "PseudoClassSelector": function PseudoClassSelectorIterator(node, context, walk) {
        var old = context.function;
        context.function = node;
        if (node.children) {
            node.children.forEach(walk);
        }
        context.function = old;
    },
    "PseudoElementSelector": function PseudoElementSelectorIterator(node, context, walk) {
        var old = context.function;
        context.function = node;
        if (node.children) {
            node.children.forEach(walk);
        }
        context.function = old;
    },
    "Rule": function RuleIterator(node, context, walk) {
        var old = context.rule;
        context.rule = node;
        walk(node.prelude);
        walk(node.block);
        context.rule = old;
    },
    "Selector": function SelectorIterator(node, context, walk) {
        node.children.forEach(walk);
    },
    "SelectorList": function SelectorListIterator(node, context, walk) {
        var old = context.selector;
        context.selector = node;
        node.children.forEach(walk);
        context.selector = old;
    },
    "StyleSheet": function StyleSheetIterator(node, context, walk) {
        var old = context.stylesheet;
        context.stylesheet = node;
        node.children.forEach(walk);
        context.stylesheet = old;
    },
    "Url": function UrlIterator(node, context, walk) {
        walk(node.value);
    },
    "Value": function ValueIterator(node, context, walk) {
        node.children.forEach(walk);
    },
};

var iteratorsReverse = {
    "Atrule": function AtruleReverseIterator(node, context, walk) {
        var old = context.atrule;
        context.atrule = node;
        if (node.block) {
            walk(node.block);
        }
        if (node.prelude) {
            walk(node.prelude);
        }
        context.atrule = old;
    },
    "AtrulePrelude": function AtrulePreludeReverseIterator(node, context, walk) {
        var old = context.atrulePrelude;
        context.atrulePrelude = node;
        node.children.forEachRight(walk);
        context.atrulePrelude = old;
    },
    "AttributeSelector": function AttributeSelectorReverseIterator(node, context, walk) {
        if (node.value) {
            walk(node.value);
        }
        walk(node.name);
    },
    "Block": function BlockReverseIterator(node, context, walk) {
        var old = context.block;
        context.block = node;
        node.children.forEachRight(walk);
        context.block = old;
    },
    "Brackets": function BracketsReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
    "Declaration": function DeclarationReverseIterator(node, context, walk) {
        var old = context.declaration;
        context.declaration = node;
        walk(node.value);
        context.declaration = old;
    },
    "DeclarationList": function DeclarationListReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
    "Function": function FunctionReverseIterator(node, context, walk) {
        var old = context.function;
        context.function = node;
        node.children.forEachRight(walk);
        context.function = old;
    },
    "MediaFeature": function MediaFeatureReverseIterator(node, context, walk) {
        if (node.value) {
            walk(node.value);
        }
    },
    "MediaQuery": function MediaQueryReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
    "MediaQueryList": function MediaQueryListReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
    "Nth": function NthReverseIterator(node, context, walk) {
        if (node.selector) {
            walk(node.selector);
        }
        walk(node.nth);
    },
    "Parentheses": function ParenthesesReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
    "PseudoClassSelector": function PseudoClassSelectorReverseIterator(node, context, walk) {
        var old = context.function;
        context.function = node;
        if (node.children) {
            node.children.forEachRight(walk);
        }
        context.function = old;
    },
    "PseudoElementSelector": function PseudoElementSelectorReverseIterator(node, context, walk) {
        var old = context.function;
        context.function = node;
        if (node.children) {
            node.children.forEachRight(walk);
        }
        context.function = old;
    },
    "Rule": function RuleReverseIterator(node, context, walk) {
        var old = context.rule;
        context.rule = node;
        walk(node.block);
        walk(node.prelude);
        context.rule = old;
    },
    "Selector": function SelectorReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
    "SelectorList": function SelectorListReverseIterator(node, context, walk) {
        var old = context.selector;
        context.selector = node;
        node.children.forEachRight(walk);
        context.selector = old;
    },
    "StyleSheet": function StyleSheetReverseIterator(node, context, walk) {
        var old = context.stylesheet;
        context.stylesheet = node;
        node.children.forEachRight(walk);
        context.stylesheet = old;
    },
    "Url": function UrlReverseIterator(node, context, walk) {
        walk(node.value);
    },
    "Value": function ValueReverseIterator(node, context, walk) {
        node.children.forEachRight(walk);
    },
};

var fastTraversalIteratorsNatural = {

    Atrule: {
        StyleSheet: iteratorsNatural.StyleSheet,
        Atrule: iteratorsNatural.Atrule,
        Rule: iteratorsNatural.Rule,
        Block: iteratorsNatural.Block
    },
    Rule: {
        StyleSheet: iteratorsNatural.StyleSheet,
        Atrule: iteratorsNatural.Atrule,
        Rule: iteratorsNatural.Rule,
        Block: iteratorsNatural.Block
    },
    Declaration: {
        StyleSheet: iteratorsNatural.StyleSheet,
        Atrule: iteratorsNatural.Atrule,
        Rule: iteratorsNatural.Rule,
        Block: iteratorsNatural.Block
    }

};

var fastTraversalIteratorsReverse = {

    Atrule: {
        StyleSheet: iteratorsReverse.StyleSheet,
        Atrule: iteratorsReverse.Atrule,
        Rule: iteratorsReverse.Rule,
        Block: iteratorsReverse.Block
    },
    Rule: {
        StyleSheet: iteratorsReverse.StyleSheet,
        Atrule: iteratorsReverse.Atrule,
        Rule: iteratorsReverse.Rule,
        Block: iteratorsReverse.Block
    },
    Declaration: {
        StyleSheet: iteratorsReverse.StyleSheet,
        Atrule: iteratorsReverse.Atrule,
        Rule: iteratorsReverse.Rule,
        Block: iteratorsReverse.Block
    }

};

module.exports = {
    types: types,
    iteratorsNatural: iteratorsNatural,
    iteratorsReverse: iteratorsReverse,
    fastTraversalIteratorsNatural: fastTraversalIteratorsNatural,
    fastTraversalIteratorsReverse: fastTraversalIteratorsReverse
};